const _camelize = require('camelize');
const _decamelize = require('decamelize-keys');

export function camelizeObjKeys(obj) {
  return _camelize(obj);
}

export function decamelizeObjKeys(obj) {
  return _decamelize(obj);
}



// WEBPACK FOOTER //
// ./src/utils/CamelizeUtils.js